import { Tabs } from 'antd'
import { Helmet } from 'react-helmet-async'
import { AssemblyStations } from './AssemblyStations'
import { Title } from '../../components/Title'
import { PrinterConfiguration } from '../printer-configuration/PrinterConfiguration'
import { BluetoothPrinterConfiguration } from '../bluetooth-printer-configuration/BluetoothPrinterConfiguration'
import { ScannerConfiguration } from '../scanner-configuration/ScannerConfiguration'
import { PORTABLE_PRINTER_ENABLED } from '../../services/BluetoothPrinterService'

export const Configurations: React.FC = () => (
  <>
    <Helmet
      title='Configuraciones - Wolf'
    />
    <Title>Configuraciones</Title>
    <Tabs
      className='mt-4'
      tabPosition={'left'}
      items={[
        {
          label: `Estanterías`,
          key: 'assembly-stations',
          children: <AssemblyStations />,
        },
        {
          label: `Impresora`,
          key: 'printer',
          children: <PrinterConfiguration />,
        },
        // Hidden until the Zebra is deployed (WET-4997) — keeps the BT feature fully off.
        ...(PORTABLE_PRINTER_ENABLED ? [{
          label: `Impresora Portátil (BT)`,
          key: 'bluetooth-printer',
          children: <BluetoothPrinterConfiguration />,
        }] : []),
        {
          label: `Escáner`,
          key: 'scanner',
          children: <ScannerConfiguration />,
        },
      ]}
    />
  </>
)
